import React from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import SummaryTable from 'components/summary/SummaryTable';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { HEADER_SPACING_PRESETS, PageHeader } from '@insurancemenu/imenu-components-lib';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { useHistory } from 'react-router-dom';
import { ContentWrapperStyled, DateStyled } from './styles';
import { createStyles } from '../../globalStyles';

const SummaryPage: React.FC = observer(() => {
  const {
    summaryTableStore: { creationDate, loading },
  } = useRootStore();

  const classes = createStyles();
  const history = useHistory();

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  const showCreationDate = !loading && creationDate;

  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <PageHeader
          title="Summary Files"
          subtitle="Browse summary files for a group"
          spacing={showCreationDate ? HEADER_SPACING_PRESETS.withActionBelow : HEADER_SPACING_PRESETS.default}
          onBackButtonClick={onBackButtonClick}
        />
        {showCreationDate && <DateStyled>{`Generated on: ${normDateToShortAmericanDate(creationDate)}`}</DateStyled>}

        <ContentWrapperStyled>
          <SummaryTable />
        </ContentWrapperStyled>
      </div>
    </ProposalStatusLayout>
  );
});

export default SummaryPage;
